import { Injectable } from '@angular/core';
import { Globals } from '../../globals';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class MailViewService {
    constructor(private global: Globals, private _httpClient: HttpClient) { }
    GetCurrentMail(id: any) {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this._httpClient.get(this.global.G_apiUrl +'/approvedEmail/'+id,{headers:headers});
    }


    GetCurrentMailPending(id: any) {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this._httpClient.get(this.global.G_apiUrl +'/emailData/'+id,{headers:headers});
    }
    GetCurrentSendMail(id: any) {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this._httpClient.get(this.global.G_apiUrl +'/sendEmail/'+id,{headers:headers});
    }

}